/** Post-registration / unlock landing. Free-flow is the only path now: always /dashboard. */
export function experimentLandingPath(_variant?: string | null): string {
  return '/dashboard';
}
